import { useState,useEffect } from "react";
import { useLocation } from 'react-router-dom';
function FormatFloatingNumber(number) {
  const parts = number.toString().split(".");

  // Extract integer and fractional parts
  const integerPart = parts[0];
  const fractionalPart = parts[1] || "";

  return (
    <span>
      <span className="formatted-number">{integerPart}</span>
      {fractionalPart !== "" ? (
        <span className="fractional">.{fractionalPart}</span>
      ) : (
        ""
      )}
    </span>
  );
}
export default function OptionsPrice() {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const theme = params.get('theme');
  console.log(theme)
  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute('data-theme', theme);
    }
  }, [theme]);
  const [Underlyingprice, setUnderlyingprice] = useState(null);
  const [strikeprice, setstrikeprice] = useState(null);
  const [Volatility, setVolatility] = useState(null);
  const [Interestrate, setInterestrate] = useState(null);
  const [Expirydate, setExpirydate] = useState(null);
  const [Dividendyield, setDividendyield] = useState(null);
  const [dict, setdict] = useState({
    callPrice: "-",
    putPrice: "-",
    callDelta: "-",
    putDelta: "-",
    gamma: "-",
    callTheta: "-",
    putTheta: "-",
    vega: "-",
  });
  const items = [
    "Underlying price",
    "Strike",
    "Volatility %",
    "Interest rate %",
    "Expiry",
    "Dividend yield %",
  ];
  function isValidFloat(value) {
    return isNaN(parseFloat(value));
  }
  function isValidDate(value) {
    const date = new Date(value);
    return isNaN(date.getTime());
  }

  function calculateOptions() {
    if (
      isValidDate(Expirydate) ||
      isValidFloat(Underlyingprice) ||
      isValidFloat(strikeprice) ||
      isValidFloat(Volatility) ||
      isValidFloat(Interestrate) ||
      isValidFloat(Dividendyield)
    ) {
      console.log("hi");
      setdict({
        callPrice: "-",
        putPrice: "-",
        callDelta: "-",
        putDelta: "-",
        gamma: "-",
        callTheta: "-",
        putTheta: "-",
        vega: "-",
      });
      return;
    }

    // User inputs
    const S = parseFloat(Underlyingprice);
    const X = parseFloat(strikeprice);
    const sigma = parseFloat(Volatility) / 100;
    const r = parseFloat(Interestrate) / 100;
    const q = parseFloat(Dividendyield) / 100;
    const currentDate = new Date();
    const expiryDate = new Date(Expirydate);
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const daysToExpiry = Math.round(
      Math.abs((currentDate - expiryDate) / oneDay)
    );
    const T = daysToExpiry / 365; // Assuming 365 days in a year

    console.log(S, X, sigma, r, q, T);
    // Calculate d1 and d2
    const d1 =
      (Math.log(S / X) + (r - q + sigma ** 2 / 2) * T) / (sigma * Math.sqrt(T));
    const d2 = d1 - sigma * Math.sqrt(T);
    // Calculate call and put prices
    const callPrice =
      S * Math.exp(-q * T) * normalCDF(d1) -
      X * Math.exp(-r * T) * normalCDF(d2);
    const putPrice =
      X * Math.exp(-r * T) * normalCDF(-d2) -
      S * Math.exp(-q * T) * normalCDF(-d1);
    // Calculate call and put deltas
    const callDelta = Math.exp(-q * T) * normalCDF(d1);
    const putDelta = -Math.exp(-q * T) * normalCDF(-d1);
    // Calculate gamma
    const gamma =
      (Math.exp(-q * T) * normalPDF(d1)) / (S * sigma * Math.sqrt(T));
    // Calculate theta
    const callTheta =
      (-S * sigma * Math.exp(-q * T) * normalPDF(d1)) / (2 * Math.sqrt(T)) -
      r * X * Math.exp(-r * T) * normalCDF(d2) +
      q * S * Math.exp(-q * T) * normalCDF(d1);
    const putTheta =
      (-S * sigma * Math.exp(-q * T) * normalPDF(d1)) / (2 * Math.sqrt(T)) +
      r * X * Math.exp(-r * T) * normalCDF(-d2) -
      q * S * Math.exp(-q * T) * normalCDF(-d1);
    // Calculate vega
    const vega = S * Math.exp(-q * T) * Math.sqrt(T) * normalPDF(d1);
    // Display results

    console.log("callPrice:", callPrice.toFixed(4));
    console.log("putPrice:", putPrice.toFixed(4));
    console.log("callDelta:", callDelta.toFixed(4));
    console.log("putDelta:", putDelta.toFixed(4));
    console.log("gamma:", gamma.toFixed(4));
    console.log("callTheta:", callTheta.toFixed(4));
    console.log("putTheta:", putTheta.toFixed(4));
    console.log("vega:", vega.toFixed(4));

    setdict({
      callPrice: callPrice.toFixed(4),
      putPrice: putPrice.toFixed(4),
      callDelta: callDelta.toFixed(4),
      putDelta: putDelta.toFixed(4),
      gamma: gamma.toFixed(4),
      callTheta: callTheta.toFixed(4),
      putTheta: putTheta.toFixed(4),
      vega: vega.toFixed(4),
    });
  }
  // Standard normal cumulative distribution function (CDF)
  function normalCDF(x) {
    return (1 + erf(x / Math.sqrt(2))) / 2;
  }
  // Standard normal probability density function (PDF)
  function normalPDF(x) {
    return Math.exp((-x * x) / 2) / Math.sqrt(2 * Math.PI);
  }
  // Error function (approximation)
  function erf(x) {
    const sign = x >= 0 ? 1 : -1;
    x = Math.abs(x);
    const a1 = 0.254829592;
    const a2 = -0.284496736;
    const a3 = 1.421413741;
    const a4 = -1.453152027;
    const a5 = 1.061405429;
    const p = 0.3275911;
    const t = 1 / (1 + p * x);
    return (
      sign *
      (1 -
        ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-x * x))
    );
  }
  return (
    <div className="fullOuter flex flex-col justify-center">
      
        <label className="main-headding">Options price calculator</label>
        <label className="scndrylbl">
          Black & Scholes Option Pricing Calculator
        </label>
        <div className="wholecomp zoomout80-2 zoom-62">
          <div className="inputgridOptions">
            <div className="inputdivs">
              <label className="inplabels">{items[0]}</label>
              <input
                type="text"
                value={Underlyingprice}
                onChange={(e) => setUnderlyingprice(e.target.value)}
              ></input>
            </div>
            <div className="inputdivs">
              <label className="inplabels">{items[1]}</label>{" "}
              <input
                type="text"
                value={strikeprice}
                onChange={(e) => setstrikeprice(e.target.value)}
              ></input>
            </div>
            <div className="inputdivs">
              <label className="inplabels">{items[4]}</label>{" "}
              <input
                type="date"
                value={Expirydate}
                onChange={(e) => setExpirydate(e.target.value)}
              ></input>
            </div>
            <div className="inputdivs">
              <label className="inplabels">{items[2]}</label>{" "}
              <input
                type="text"
                value={Volatility}
                onChange={(e) => setVolatility(e.target.value)}
              ></input>
            </div>
            <div className="inputdivs">
              <label className="inplabels">{items[3]}</label>{" "}
              <input
                type="text"
                value={Interestrate}
                onChange={(e) => setInterestrate(e.target.value)}
              ></input>
            </div>

            <div className="inputdivs">
              <label className="inplabels">{items[5]}</label>{" "}
              <input
                type="text"
                value={Dividendyield}
                onChange={(e) => setDividendyield(e.target.value)}
              ></input>
            </div>
            <button onClick={calculateOptions} >
              Calculate
            </button>
          </div>
          <div className="callandputs optioncallandputs">
            <label className="callscontainer">Calls Vs Puts</label>
            <div className="Pricecontaineroptions">
              <div>
                {dict["callPrice"] === "-" ? (
                  <label className="outputval">{dict["callPrice"]}</label>
                ) : (
                  <label className="outputval">
                    {FormatFloatingNumber(dict["callPrice"])}
                  </label>
                )}
                <label>Call price</label>
              </div>
              <div>
                {dict["putPrice"] === "-" ? (
                  <label className="outputval">{dict["putPrice"]}</label>
                ) : (
                  FormatFloatingNumber(dict["putPrice"])
                )}
                <label>Put price</label>
              </div>
            </div>
            <div className="optioncompcont">
              <div className="compcont">
                <div>
                  {dict["callDelta"] === "-" ? (
                    <label className="outputval">{dict["callDelta"]}</label>
                  ) : (
                    <label className="outputval">
                      {FormatFloatingNumber(dict["callDelta"])}
                    </label>
                  )}
                  <label>Call Delta</label>
                </div>
                <div className="flexend">
                  {dict["callTheta"] === "-" ? (
                    <label className="outputval">{dict["callTheta"]}</label>
                  ) : (
                    <label className="outputval">
                      {FormatFloatingNumber(dict["callTheta"])}
                    </label>
                  )}
                  <label>Call Theta</label>
                </div>
                <div>
                  {dict["gamma"] === "-" ? (
                    <label className="outputval">{dict["gamma"]}</label>
                  ) : (
                    <label className="outputval">
                      {FormatFloatingNumber(dict["gamma"])}
                    </label>
                  )}
                  <label>Call Gamma</label>
                </div>
                <div className="flexend">
                  {dict["vega"] === "-" ? (
                    <label className="outputval">{dict["vega"]}</label>
                  ) : (
                    <label className="outputval">
                      {FormatFloatingNumber(dict["vega"])}
                    </label>
                  )}
                  <label>Call Vega</label>
                </div>
              </div>
              <div className="compcont">
                <div>
                  {dict["putDelta"] === "-" ? (
                    <label className="outputval">{dict["putDelta"]}</label>
                  ) : (
                    FormatFloatingNumber(dict["putDelta"])
                  )}
                  <label>Put Delta</label>
                </div>
                <div className="flexend">
                  {dict["putTheta"] === "-" ? (
                    <label className="outputval">{dict["putTheta"]}</label>
                  ) : (
                    FormatFloatingNumber(dict["putTheta"])
                  )}
                  <label>Put Theta</label>
                </div>
                <div>
                  {dict["gamma"] === "-" ? (
                    <label className="outputval">{dict["gamma"]}</label>
                  ) : (
                    FormatFloatingNumber(dict["gamma"])
                  )}
                  <label>Put Gamma</label>
                </div>
                <div className="flexend">
                  {dict["vega"] === "-" ? (
                    <label className="outputval">{dict["vega"]}</label>
                  ) : (
                    FormatFloatingNumber(dict["vega"])
                  )}
                  <label>Put Vega</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  );
}
